<template>
  <!-- 消息推送 -->
  <div class="informMan">
    <!-- 面包屑导航 -->
    <crumbs-bar @refresh="handleRefresh" :crumbsList="['资讯管理',$route.meta.title]">
      <template slot="controls">
        <el-button type="primary" icon="el-icon-edit" @click="handleCreate">创建消息</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-input style="width:200px;margin-right:5px" clearable
          placeholder="输入编号/名称" v-model="searchForm.name"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="getTableData(1)">搜索</el-button>
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%">
      <el-table-column
        type="selection"
        align="center"
        width="55">
      </el-table-column>
      <el-table-column
        align="center"
        prop="type"
        show-overflow-tooltip
        label="类型">
      </el-table-column>
      <el-table-column
        prop="range"
        align="center"
        show-overflow-tooltip
        label="推送范围">
      </el-table-column>
      <el-table-column
        prop="time"
        label="推送时间"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="url"
        label="URL地址"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="isPush"
        label="是否推送"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="isPublish"
        label="是否发布"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="content"
        label="类容"
        align="center"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.row.isPublish == '否'" type="success" style="padding:2px 3px;" plain @click="changeStatus(scope.row,'Y')">上架</el-button>
          <el-button v-else type="danger" style="padding:2px 3px;" plain @click="changeStatus(scope.row,'N')">下架</el-button>
          <el-button type="danger" style="padding:2px 3px;" plain @click="changeStatus(scope.row,'X')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination :allPage="allPage" :pageSize="pageSize" :currIndex="currPage"
      @hanSiChange="hanSiChange" @hanCurrChange="hanCurrChange"></pagination>
    <!-- 创建消息 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl">
      <div class="drawer-header">
        消息创建
      </div>
      <el-scrollbar style="height:calc(100% - 90px);">
        <div class="drawer-form-wrap">
          <el-form :model="addForm" label-position="rigth" label-width="80px"
            :rules="formRule" ref="addForm">
            <el-form-item label="消息类型" prop="msgType">
              <el-select v-model="addForm.msgType" placeholder="请选择" clearable style="width:100%">
                <el-option label="公告" value="公告"></el-option>
                <el-option label="积分" value="积分"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型" prop="clientType">
              <el-select v-model="addForm.clientType" placeholder="请选择" clearable style="width:100%">
                <el-option label="全部" value=""></el-option>
                <el-option label="终端" value="F001"></el-option>
                <el-option label="连锁" value="F002"></el-option>
                <el-option label="批发" value="F003"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始日期" prop="startTime">
              <el-date-picker
                v-model="addForm.startTime"
                type="datetime"
                style="width:100%;"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="标题" prop="title">
              <el-input v-model="addForm.title" clearable></el-input>
            </el-form-item>
            <el-form-item label="url地址" prop="url">
              <el-input v-model="addForm.url" clearable></el-input>
            </el-form-item>
            <el-form-item label="内容" prop="classify">
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8}"
                placeholder="请输入内容"
                v-model="addForm.classify">
              </el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js";//混入表单必填项

export default {
  name: 'informMan',
  data() {
    return {
      /**表格数据 */
      //序号	类型	推送范围	推送时间	标题	Url地址	是否推送	是否发布	类容	操作
      tableData:[{
        type:"类型",
        range:"推送范围",
        time:"推送时间",
        title:"标题",
        url:"URL地址",
        isPush:"是否推送",
        isPublish:"是否发布",
        content:"类容"
      }],
      /**分页数据 */
      currPage:1,
      pageSize:20,
      allPage:0,
      addDrawer:false,/**创建消息drawer */
      /**表单数据 */
      //消息类型 客户类型 开始时间日期 标题 url地址 类容
      addForm:{
        msgType:"",
        clientType:"",
        startTime:"",
        title:"",
        url:"",
        classify:""
      },
      formRule:{/**表单验证 */
        msgType: [mustFill],
        startTime: [mustFill],
        title: [mustFill],
        classify: [mustFill]
      },
      searchForm:{
        name:""
      }
    }
  },
  created() {
    this.getTableData()
  },
  components: {
    
  },
  methods:{
    /**获取表格数据 */
    getTableData(num){
      this.currPage = num == 1 ? 1 : this.currPage
      var proc = "Proc_AppPuse";//存储过程名
      var type = "DataTable";
      let data = {
        entId: window.localStorage.getItem('entId'),
        type: "QueryPush",
        Procedure: proc,
        name: this.searchForm.name,
        PageIndex: this.currPage + '',
        pageSize: this.pageSize + ''
      }
      this.$requestSys({
        url:"AppPush/ashx/ReturnDataTable.ashx?Type=" + type + "&Json=" + encodeURI(JSON.stringify(data)),
        method:"post",
      }).then((res) => {
        console.log(res);
        this.allPage = res.recordCount;
        this.tableData = [];
        if (res.return_code == 0) {
          for (let i = 0; i < res.data.length; i++) {
            this.tableData.push({
              id: res.data[i].id,
              type: res.data[i].type,
              range: res.data[i].khlx,
              time: res.data[i].create_time,
              title: res.data[i].title,
              url: res.data[i].web_url,
              isPush: res.data[i].is_post == 'Y' ? '是' : '否',
              isPublish: res.data[i].beactive == 'Y' ? '是' : '否',
              content: res.data[i].content,
            })
          }
        }
      }).catch((err) => {
        window.console.log(err);
      });
    },
    /**分页size改变 */
    hanSiChange(val){
      this.pageSize = val;
      this.getTableData()
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    /**刷新表格数据 */
    handleRefresh(){
      this.getTableData();
    },

    /**创建消息 */
    handleCreate(){
      this.addDrawer = true;
    },
    /**提交表单 */
    submitForm(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          let SqlProcedure = "Proc_AppPuse";
          let Type = "ExecuteNonQuery";
          let data = {
            Type: "CreateAppPuse",
            Procedure: SqlProcedure,
            TypeId: this.addForm.msgType,
            khlx: this.addForm.clientType,
            Date: this.addForm.startTime.split(' ')[0],
            Time: this.addForm.startTime.split(' ')[1],
            name: this.addForm.title,
            Url: this.addForm.url,
            notes: this.addForm.classify,
          };
          this.$requestSys({
            method: 'post',
            url: "AppPush/ashx/ReturnDataTable.ashx?Type=" + Type + "&Json=" + encodeURI(JSON.stringify(data)),
          }).then(res => {
            console.log(res);
            if(res.return_code == 0){
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.clearForm()
              this.getTableData()
            }else{
              this.$message({
                message: res.data[0].message,
                type: 'warning'
              })
            }
          })
        }
      });
    },
    /**关闭drawer 清空表单信息 */
    clearForm(){
      this.$refs['addForm'].resetFields();
      this.addDrawer = false;
    },

    changeStatus(row,status){
      let msg = '确定要执行操作吗?'
      let type = 'info'
      if(status == 'Y'){
        msg = '确定上架吗?'
        type = 'success'
      } else if(status == 'N'){
        msg = '确定下架吗?'
        type = 'warning'
      } else if(status == 'X'){
        msg = '确定删除吗?'
        type = 'error'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: type
      }).then(() => {
        let SqlProcedure = "Proc_AppPuse";
        let Type = "ExecuteNonQuery";
        let data = {
          Type: "Update",
          Procedure: SqlProcedure,
          TypeId: status,
          ID: row.id
        };
        this.$requestSys({
          method: 'post',
          url: "AppPush/ashx/ReturnDataTable.ashx?Type=" + Type + "&Json=" + encodeURI(JSON.stringify(data)),
        }).then(res => {
          if(res.return_code == 0){
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getTableData()
          }else{
            this.$message({
              message: res.data[0].message,
              type: 'error'
            })
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.informMan{
  width: 100%;
  height: 100%;
}
</style>
